export class PasswordConstants {
    public static requestPasswordResetUrl = 'retail-web/password-reset-requests';
    public static resubmitConfirmationMessage = 'Another request has been sent to reset your password. Please check your email.';
}
